<template>
  <v-app id="app">
    <!-- 导航栏 -->
    <TopNavBar></TopNavBar>
    <!-- 侧边导航栏 -->
    <SideNavBar></SideNavBar>
    <!-- 内容 -->
    <v-content>
      <router-view :key="$route.fullPath" />
    </v-content>
    <!-- 页脚 -->
    <Footer></Footer>
    <!-- 返回顶部 -->
    <BackTop></BackTop>
    <!-- 搜索模态框 -->
    <searchModel></searchModel>
    <!-- 登录模态框 -->
    <LoginModel></LoginModel>
    <!-- 注册模态框 -->
    <RegisterModel></RegisterModel>
    <!-- 忘记密码模态框 -->
    <ForgetModel></ForgetModel>
    <!-- 绑定邮箱模态框 -->
    <EmailModel></EmailModel>
    <!-- 音乐播放器 -->
    <Player v-if="blogInfo.webSite.isMusicPlayer === 1 && !isMobile" />
    <!-- 聊天室 -->
    <ChatRoom v-if="0 == 1"></ChatRoom>
    <FeedBack />
  </v-app>
</template>

<script>
import TopNavBar from "./components/layout/TopNavBar";
import SideNavBar from "./components/layout/SideNavBar";
import Footer from "./components/layout/Footer";
import BackTop from "./components/BackTop";
import searchModel from "./components/model/SearchModel";
import LoginModel from "./components/model/LoginModel";
import RegisterModel from "./components/model/RegisterModel";
import ForgetModel from "./components/model/ForgetModel";
import EmailModel from "./components/model/EmailModel";
import Player from "./components/zw-player/player.vue";
//import ChatRoom from "./components/ChatRoom";
import FeedBack from "./components/FeedBack";
import { getWebSiteInfo, report } from './api'
export default {
  mounted() {
    this.getBlogInfo()
    // 上传访客信息
    // report();
  },
  components: {
    TopNavBar,
    Player,
    SideNavBar,
    Footer,
    BackTop,
    searchModel,
    LoginModel,
    RegisterModel,
    ForgetModel,
    EmailModel,
    FeedBack
  },
  methods: {
    getBlogInfo() {
      getWebSiteInfo().then(res => {
        this.$store.commit("checkBlogInfo", res.data);
      });
    },
  },
  computed: {
    blogInfo() {
      return this.$store.state.blogInfo;
    },
    isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style>
  .sw-search-btn {
        margin-top: 5px;
        margin-bottom: 2px;
  }

  .sw-search-wrapper {
        vertical-align: middle;
        position: relative;
        border: 1px solid #e7e7e7;
        box-shadow: 0 0 1px 1px #f4f4f4;
        padding-left: 2px;
        padding-right: 2px;
        margin-top: 2px;
        /*margin-right: 10px;*/
        margin-left: 0px;
        transition: all ease-in-out .2s;
        margin-bottom: 9px;
        width: 200px;
        display: inline-table;
    }

    .sw-search-input input {
        border: 0 !important;
    } 

    .custom-button {
    border: none;  /* 移除边框样式 */
    background-color: inherit;
  }

  .centerContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* 如果要元素垂直居中显示，则需要确定父容器有足够的高度 */
  }
</style>